/**
 * Data curta do sino de avisos (mockup `state-bell`, 17tm466frtx): "hoje, HH:mm",
 * "ontem, HH:mm" ou "dd/MM, HH:mm" pra qualquer dia mais velho — a 2ª linha de
 * cada aviso, embaixo da mensagem. Função pura, sem Angular: dá pra testar sem
 * levantar o `HeaderComponent` inteiro (que puxa carteira, WhatsApp, Call4U...).
 */
export function formatNotificationDate(date: Date | string, now: Date = new Date()): string {
  const when = date instanceof Date ? date : new Date(date);
  const pad = (value: number): string => String(value).padStart(2, '0');
  const time = `${pad(when.getHours())}:${pad(when.getMinutes())}`;

  const startOfDay = (value: Date): number => new Date(value.getFullYear(), value.getMonth(), value.getDate()).getTime();
  const diffDays = Math.round((startOfDay(now) - startOfDay(when)) / 86400000);

  if (diffDays === 0) {
    return `hoje, ${time}`;
  }
  if (diffDays === 1) {
    return `ontem, ${time}`;
  }
  return `${pad(when.getDate())}/${pad(when.getMonth() + 1)}, ${time}`;
}
